import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {
    Grid,
    IconButton,
    LinearProgress,
    MenuItem,
    TextField,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useSnackbar } from 'notistack';
import { Box } from '@mui/system';

import { getDataList } from '../../../helpers/getDataList';
import { sendJsonData } from '../../../helpers/sendJsonData';
import showMessage from '../../../helpers/showMessage';
import PageHeader from '../includes/PageHeader';
import { DateTimePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import SearchIcon from '@mui/icons-material/Search';
import { ERROR_MESSAGES } from '../../../configs/messages';
import RemoveIcon from '@mui/icons-material/Remove';
import ClearIcon from '@mui/icons-material/Clear';
import renderCellExpand from '../../feature/GridCellExpand';
import { format, parseISO } from 'date-fns';



export function ArchiveList() {
    const columns = [
        // {
        //     field: 'id',
        //     headerName: 'ID',
        //     flex: 1,
        // },
        {
            field: 'broadcastDate',
            headerName: 'Өдөр',
            flex: 1,
        },
        {
            field: 'broadcastTime',
            headerName: 'Цаг',
            flex: 1,
        },
        {
            field: 'duration',
            headerName: 'Үргэлжлэх хугацаа',
            flex: 1,
        },
        {
            field: 'name',
            headerName: 'Хөтөлбөрийн нэр',
            flex: 1,
            renderCell: renderCellExpand,
        },
        // {
        //     field: 'isRepeat',
        //     headerName: 'Давтагдах эсэх',
        //     flex: 1,
        // },
        {
            field: 'programType',
            headerName: 'Төрөл',
            flex: 1,
            renderCell: renderCellExpand,
        },
        {
            field: 'imgUrl',
            headerName: 'Зураг',
            flex: 1,
            renderCell: (params) => {
                return (
                    <div>
                        {params.value ? (
                            <img
                                src={params.value}
                                style={{
                                    height: '30px',
                                    width: '40px',
                                    objectFit: 'cover',
                                }}
                                alt="зураг"
                            />
                        ) : (
                            <></>
                        )}
                    </div>
                );
            },
        },
        {
            field: 'description',
            headerName: 'Тайлбар',
            flex: 1,
        },
        {
            field: 'channel',
            headerName: 'ТВ суваг',
            flex: 1,
        },
        // {
        //     field: 'isApproved',
        //     headerName: 'Батлагдсан эсэх',
        //     flex: 1,
        //
        // },
    ];

    const [isLoading, setIsLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const [programList, setProgramList] = useState([]);
    const [updateList, setUpdateList] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [initialData, setInitialData] = useState({
        startDate: format(new Date(), "yyyy-MM-dd'T'HH:mm"),
        endDate: format(new Date(), "yyyy-MM-dd'T'HH:mm"),
        channelId: '',
    });
    const [pageSize, setPageSize] = useState(100);
    const [channelList, setChannelList] = useState([]);

   const localizedTextsMap = {
  columnMenuUnsort: "Ангилаагүй",
  columnMenuSortAsc: "Өсөхөөр эрэмблэх",
  columnMenuSortDesc: "Буурахаар эрэмблэх",
  columnMenuFilter: "Хайх",
  columnMenuHideColumn: "Нуух",
  columnMenuShowColumns: "Багана харах"
};
    useEffect(() => {
        let isActive = true;

        getDataList('archive')
            .then((response) => {
                if (isActive) {
                    const dataArr = response.data?.data;

                    dataArr.forEach((data) => {
                        data.isRepeat =
                            data.isRepeat === false ? 'Үгүй' : 'Тийм';
                        // data.isApproved =
                        //     data.isApproved === '0' ? 'Үгүй' : 'Тийм';
                        data.channel = data?.epgProgram?.channel?.name;
                        data.programType = data?.programType?.name;
                    });

                    setProgramList(dataArr);
                }
                setIsLoading(false);
            })
            .catch((error) => {
                const message = error.response?.data?.message
                    ? error.response.data.message
                    : error.message;
                showMessage(message, enqueueSnackbar, 'error');
            });

        getDataList('channel')
            .then((response) => {
                if (isActive) {
                    const allChannel = response.data?.data;
                    if (allChannel.length === 1) {
                        setInitialData({
                            ...initialData,
                            'channelId': allChannel[0].id,
                        });
                    }
                    setChannelList(response.data?.data);
                }
            })
            .catch((error) => {
                const message = error.response?.data?.message
                    ? error.response.data.message
                    : error.message;
                showMessage(message, enqueueSnackbar, 'error');
            });

        return () => {
            isActive = false;
        };
    }, [updateList]);

    const validate = () => {
        let tempErrors = { ...errors };
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;

        if ('startDate' in initialData) {
            tempErrors.startDate = initialData.startDate ? '' : requiredMessage;
        }

        if ('endDate' in initialData) {
            tempErrors.endDate = initialData.endDate ? '' : requiredMessage;

            console.log(initialData.startDate, initialData.endDate)
            if(initialData.startDate >= initialData.endDate){
                tempErrors.endDate = ERROR_MESSAGES.DATE_ERROR;
            }
        }


        setErrors({
            ...tempErrors,
        });
        return tempErrors;
    };
    

    const handleSubmit = (e) => {
        e.preventDefault();

        const tempErrors = validate();
        for (const key in tempErrors) {
            if (tempErrors[key]) {
                showMessage(
                    ERROR_MESSAGES.FILL_THE_FORM,
                    enqueueSnackbar,
                    'error',
                );
                return;
            }
        }

        sendJsonData(initialData, 'archive/filter', false)
            .then((response) => {
                const dataArr = response.data?.data;

                dataArr.forEach((data) => {
                    data.isRepeat = data.isRepeat === false ? 'Үгүй' : 'Тийм';
                    data.isApproved = data.isApproved === '0' ? 'Үгүй' : 'Тийм';
                    data.channel = data?.epgProgram?.channel?.name;
                    data.programType = data?.programType?.name;
                });
                setProgramList(dataArr);
                // setProgramList(dataArr);
            })
            .catch((error) => {
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    };

    const handleClearFilter = (e) => {
        e.preventDefault();
        setUpdateList(!updateList);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInitialData({
            ...initialData,
            [name]: value,
        });
    };
    return (
        <Grid
            container
            justifyContent="center"
            style={{ height: 630, width: '100%' }}
        >
            <PageHeader pageName="Дэлгэрэнгүй Хөтөлбөр" showAddNew={false} />
            {isLoading ? (
                <Box sx={{ width: '100%' }}>
                    <LinearProgress />
                </Box>
            ) : (
                <>
                    <Grid
                        item
                        container
                        gap="10px"
                        style={{ margin: '20px 0' }}
                    >
                        <TextField
                            id="archive-datetime-start"
                            label="Эхлэх огноо"
                            type="datetime-local"
                            value={initialData.startDate}
                            // defaultValue="2017-05-24T10:30"
                            sx={{ width: 250 }}
                            InputLabelProps={{
                            shrink: true,
                            }}
                            onChange={handleInputChange}
                            name="startDate"
                            error={Boolean(errors.startDate)}
                            helperText={errors.startDate}
                        />
                            <RemoveIcon style={{ padding: '15px 5px' }} />

                            <TextField
                            id="archive-datetime-end"
                            label="Дуусах огноо"
                            type="datetime-local"
                            value={initialData.endDate}
                            // defaultValue="2017-05-24T10:30"
                            sx={{ width: 250 }}
                            InputLabelProps={{
                            shrink: true,
                            }}
                            onChange={handleInputChange}
                            name="endDate"
                            error={Boolean(errors.endDate)}
                            helperText={errors.endDate}
                        />
                           
                        <TextField
                            style={{ width: 250, marginLeft: '20px' }}
                            id="archive-select"
                            select
                            value={initialData.channelId}
                            label="ТВ"
                            onChange={handleInputChange}
                            name="channelId"
                            error={Boolean(errors.channelId)}
                            helperText={errors.channelId}
                            variant="outlined"
                        >
                            <MenuItem value="">
                                <em>Сонго</em>
                            </MenuItem>
                            {channelList.map((type) => (
                                <MenuItem key={type.id} value={type.id}>
                                    {type.name}
                                </MenuItem>
                            ))}
                        </TextField>
                        {/* </Grid> */}
                        <Tooltip title="Хайх">
                            <IconButton
                                color="success"
                                onClick={(e) => handleSubmit(e)}
                            >
                                <SearchIcon fontSize="large" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Цэвэрлэх">
                            <IconButton
                                color="error"
                                onClick={(e) => handleClearFilter(e)}
                            >
                                <ClearIcon fontSize="large" />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    <DataGrid
                        rows={programList}
                        columns={columns}
                        pageSize={pageSize}
                        onPageSizeChange={(newPage) => setPageSize(newPage)}
                        rowsPerPageOptions={[]}
                        pagination
                        localeText={localizedTextsMap}
                        // checkboxSelection
                        disableSelectionOnClick
                    />
                </>
            )}
        </Grid>
    );
}
